import React, { Children, Component } from 'react';
import { motion } from 'framer-motion';
import { BedDouble, ShowerHead, Droplets, Car } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const fade = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
function AreaStat({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <motion.div variants={fade} className="text-center" data-id="element-164" data-mp="18tytziffkrzh">
      <p className="text-[0.7rem] md:text-sm tracking-widest font-light text-text-muted" data-id="element-165" data-mp="1nsakf7c7n4i7">
        {label}
      </p>
      <p className="mt-2 md:mt-4 text-4xl md:text-6xl font-light text-primary leading-none" data-id="element-166" data-mp="1itpo3j02x4z1">
        {value}
        <span className="align-super text-sm md:text-2xl ml-0.5 md:ml-1 font-light text-text-muted" data-id="element-167" data-mp="3pjx6qvl5qb8c">
          m²
        </span>
      </p>
    </motion.div>;
}
function CountStat({
  label,
  value,
  icon: Icon
}: {
  label: string;
  value: string;
  icon: ComponentType<{
    className?: string;
    strokeWidth?: number;
  }>;
}) {
  return <motion.div variants={fade} className="text-center flex flex-col items-center" data-id="element-168" data-mp="11g917dwq9mm6">
      <p className="text-[0.7rem] md:text-sm tracking-widest font-light text-text-muted" data-id="element-169" data-mp="166z4mlllffe8">
        {label}
      </p>
      <div className="mt-2 md:mt-4 flex items-center justify-center gap-2 md:gap-3" data-id="element-170" data-mp="1b6lj0yd5r1om">
        <Icon className="w-6 h-6 md:w-8 md:h-8 text-accent" strokeWidth={1} data-id="element-171" data-mp="1g555czvnyfhi" />
        <span className="text-3xl md:text-5xl font-light text-primary" data-id="element-172" data-mp="1g79jsbr6uww1">
          {value}
        </span>
      </div>
    </motion.div>;
}
export function StatsSection() {
  return <section className="w-full bg-bg-warm py-14 md:py-20 px-6 md:px-14 relative z-10" data-id="element-173" data-mp="1p5biulrd3fgo">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={container} className="max-w-5xl mx-auto space-y-10 md:space-y-12" data-id="element-174" data-mp="3lzeutl6qetk5">
        {/* Card 1: areas */}
        <div className="grid grid-cols-3 gap-4 sm:gap-6" data-id="element-175" data-mp="t4oiz5ohmrn1">
          <AreaStat label="Floor Area" value="610" data-id="element-176" data-mp="173edqenu4f88" />
          <AreaStat label="Lot Area" value="475" data-id="element-177" data-mp="1747cotgjy0ft" />
          <AreaStat label="Garden" value="190" data-id="element-178" data-mp="124bbt335ip4h" />
        </div>

        <div className="w-full h-px bg-black/5" data-id="element-179" data-mp="12303qr2oav7k" />

        {/* Card 2: counts */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 md:gap-6" data-id="element-180" data-mp="1h0ansotdt9ew">
          <CountStat label="Bedrooms" value="5" icon={BedDouble} data-id="element-181" data-mp="1c1fxl1t34ikr" />
          <CountStat label="Baths" value="5" icon={ShowerHead} data-id="element-182" data-mp="1ptw1e4tt8kmq" />
          <CountStat label="Powder Room" value="1" icon={Droplets} data-id="element-183" data-mp="1pt46yxby8sy1" />
          <CountStat label="Car Park" value="4" icon={Car} data-id="element-184" data-mp="1ltdbwhfe3qnp" />
        </div>
      </motion.div>
    </section>;
}